<div class="container">
	<app-payment-check (loaded)="checkPayment($event)"></app-payment-check>
	<div class="d-flex flex-wrap gap-1 mt-1">
		<div class="my-1">
			<select class="form-control mx-2" [(ngModel)]="selectedStatus">
				<option value="NotPaid,Pending,Started,Rejected">وضعیت آگهی</option>
				<option *ngFor='let status of ["NotPaid","Pending","Started","Rejected"]' [value]="status">{{status |
					readable:"RtwadStatus"}}</option>
			</select>
		</div>

		<a class="btn btn-primary mr-auto" [routerLink]="'post'">
			<span>ثبت آگهی آماده به کار </span>
		</a>

	</div>
	<div *ngIf="(search$ | async) as search">
		<div class="kp-card" *ngFor="let rtwad of search.List | filter:{Status: selectedStatus | split:','} | sort:'RegisterTime':false ">
			<app-rtwad-summary [rtwad]="rtwad" mode="owner" rtwadPath="/account/rtw" (updated)="onAdUpdated()"></app-rtwad-summary>
		</div>
		<div *ngIf="search.List.length==0" class="text-center my-5 fs-lg fw-bold">
			<span>شما هیچ آگهی آماده به کاری ندارید</span>
		</div>
	</div>
</div>
